import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {api} from '../../../api/api-dictionnary';
import {Subscription} from 'rxjs';
import {HydraService} from '../../../core/services/hydra.service';
import {LaboratoireReference} from '../../../class/api/LaboratoireReference';
import {Personne} from '../../../class/api/Personne';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { UpperCasePipe } from '@angular/common';
import { MatIconButton, MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-choix-laboratoire-reference',
    templateUrl: './modal-choix-laboratoire-reference.component.html',
    styleUrls: ['./modal-choix-laboratoire-reference.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatIcon, FormsModule, MatIconButton, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, MatDialogActions, MatDialogClose, UpperCasePipe, TranslateModule]
})
export class ModalChoixLaboratoireReferenceComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalChoixLaboratoireReferenceComponent>>(MatDialogRef);
    private hydraService = inject(HydraService);
    private cdr = inject(ChangeDetectorRef);

    public subscriptions: Subscription[] = [];
    public selectedSort = null;
    public search = '';
    public _timeout = null;
    public laboratoireDeReferenceSelected = [];
    public modeNouveauLabodatoire = false;
    public nouveauLaboratoire = new LaboratoireReference({
        directeur: new Personne(),
        adresse: null,
    });

    public displayNewLab = false;
    public MATERIAL_COLUMNS = ['label', 'sigle', 'directeur.nom', 'action'];
    public pageSizeOptions = [10,20,30,50,100];
    public total = 0;

    public laboratoires = new MatTableDataSource<LaboratoireReference>([]);
    @ViewChild(MatSort, {static: false}) sort: MatSort;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    constructor() {
        const data = this.data;

        this.displayNewLab = data.newReference;
    }

    public getCollection(url) {
        this.subscriptions.push(
            this.hydraService.getList(url).subscribe((res: HydraCollection) => {
                this.total = +res['hydra:totalItems'];
                this.laboratoires.data = res.getMember();

            })
        );
    }

    public getSearchIfExist() {
        return this.search != null && this.search.length ? this.search : null;
    }

    public construcUrlCollection(search = null) {
        let url = api.laboratoiresReferences;
        const wantPage = this.paginator.pageIndex + 1 ;
        url += `?page=${wantPage}&itemsPerPage=${this.paginator.pageSize}&etat=1`;

        if (search) {url += '&search=' + search;}
        if (this.selectedSort && this.selectedSort.active && this.selectedSort.direction) {
            url += '&order[' + this.selectedSort.active + ']=' + this.selectedSort.direction;
        } else {
            url += '&order[label]=asc';
        }

        return url;
    }

    public onChangeResearch(event) {
        if (this._timeout) {
            //if there is already a timeout in process cancel it
            window.clearTimeout(this._timeout);
        }
        this._timeout = window.setTimeout(() => {
            this._timeout = null;
            this.selectedSort = null;
            this.refreshFilters();
        }, 500);
    }

    public compareByValue(itemOne, itemTwo) {
        return itemOne == itemTwo;
    }

    public laboratoireValid() {
        return this.laboratoireDeReferenceSelected.length;
    }

    submitWithSelection(laboratoire) {
        this.dialogRef.close(laboratoire);
    }

    ngOnInit() {
        this.paginator.pageSize = 10;

        this.getCollection(this.construcUrlCollection());
    }

    private refreshFilters() {
        this.reinitPagerParams();
        this.getCollection(this.construcUrlCollection(this.getSearchIfExist()));
    }

    public changeSort(event: {active: string;direction: string}){

        if (event) {
            this.selectedSort = event;
            this.refreshFilters();
        }
        return false;
    }

    public onPaginatorPageChange() {
        this.getCollection(
            this.construcUrlCollection(
                this.getSearchIfExist()
            )
        );
    }

    private reinitPagerParams() {
        this.paginator.pageIndex = 0;
    }

    public selectLaboratoireReference(item: LaboratoireReference) {
        this.laboratoireDeReferenceSelected = [item];
    }
}
